<template>
    <div class="login-signup-section">
        <div class="header-logo">
            <router-link :to="{ path: 'apps' }" class="mx-auto">
                <img src="/assets/img/logo.svg" alt="" width="232">
            </router-link>
        </div>
        <div class="login-left-part d-md-flex align-items-center">
            <div class="thanks-signing" style="margin:auto;">
                <span v-if="verified === null">
                    <p>Verifying...</p>
                    <div class="see-more-comments">
                        <svg  class="rotate-infinite"
                              xmlns="http://www.w3.org/2000/svg" width="18" height="15" viewBox="0 0 18 15"><g><g><path fill="#8e8e93" d="M2.936 5.288l1.65 1.687a.75.75 0 1 1-1.073 1.05l-.36-.367C3.231 10.913 5.834 13.5 9 13.5a5.763 5.763 0 0 0 4.355-1.995.75.75 0 1 1 1.129.99C13.141 14.025 11.184 15 9 15c-4.025 0-7.27-3.292-7.349-7.35l-.365.375a.75.75 0 0 1-1.072-1.05l1.65-1.687a.757.757 0 0 1 .536-.225c.202 0 .395.082.536.225zM9 1.5a5.763 5.763 0 0 0-4.355 1.995.75.75 0 1 1-1.129-.99C4.859.975 6.816 0 9 0c4.025 0 7.27 3.293 7.349 7.35l.365-.375a.75.75 0 0 1 1.072 1.05l-1.65 1.688a.757.757 0 0 1-.536.225.757.757 0 0 1-.536-.225l-1.65-1.688a.75.75 0 0 1 1.073-1.05l.36.368C14.769 4.088 12.166 1.5 9 1.5z"/></g></g></svg>
                    </div>
                </span>
                <span v-else-if="verified">
                    <p>Thanks for verifying your email. You can now sign in.</p>
                    <p>Redirecting...</p>
                    <div class="see-more-comments">
                        <svg  class="rotate-infinite"
                              xmlns="http://www.w3.org/2000/svg" width="18" height="15" viewBox="0 0 18 15"><g><g><path fill="#8e8e93" d="M2.936 5.288l1.65 1.687a.75.75 0 1 1-1.073 1.05l-.36-.367C3.231 10.913 5.834 13.5 9 13.5a5.763 5.763 0 0 0 4.355-1.995.75.75 0 1 1 1.129.99C13.141 14.025 11.184 15 9 15c-4.025 0-7.27-3.292-7.349-7.35l-.365.375a.75.75 0 0 1-1.072-1.05l1.65-1.687a.757.757 0 0 1 .536-.225c.202 0 .395.082.536.225zM9 1.5a5.763 5.763 0 0 0-4.355 1.995.75.75 0 1 1-1.129-.99C4.859.975 6.816 0 9 0c4.025 0 7.27 3.293 7.349 7.35l.365-.375a.75.75 0 0 1 1.072 1.05l-1.65 1.688a.757.757 0 0 1-.536.225.757.757 0 0 1-.536-.225l-1.65-1.688a.75.75 0 0 1 1.073-1.05l.36.368C14.769 4.088 12.166 1.5 9 1.5z"/></g></g></svg>
                    </div>
                </span>

                <span v-else>
                    <p class="invalid-feedback">Unable to verify!</p>
                    <router-link :to="{ path: '/apps' }" class="btn btn-primary">Home</router-link>
                </span>
            </div>
        </div>
        <div class="login-right-part">
            <div class="login-right-logo">
                <img src="/assets/img/right-logo.svg" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "../api/api.service";

export default {
    name: "EmailVerify.vue",
    data: function () {
        return {
            verified: null,
            loaded: false,
        };
    },
    mounted() {
        ApiService.post('/api/email/verify', this.$route.query)
        .then(({data}) => {
            this.verified = true;
            setTimeout(() => {
                this.$router.push({ path: '/login' })
            }, 2000);
        })
        .catch((res) => {
            this.loaded = true;
            this.verified = false;
        });
    }
}
</script>

<style scoped>

</style>
